import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What is the Super 50 Program?',
      answer: 'The Super 50 Program is an intensive 3-6 months training program designed to create job-ready professionals. It includes industry-relevant curriculum, hands-on projects, mentorship from experts, and placement assistance.'
    },
    {
      question: 'What technologies do you teach?',
      answer: 'We offer training in a wide range of technologies including Java, Python, Full Stack Development, React, Node.js, Cloud Computing (AWS), AI/ML, Mobile Development, DevOps, and more. Our curriculum is regularly updated to match industry demands.'
    },
    {
      question: 'Do you provide placement assistance?',
      answer: 'Yes! We provide comprehensive placement assistance including resume building, interview preparation, mock interviews, and direct connections to our corporate partners. We have a 95% success rate with 500+ students placed in top companies.'
    },
    {
      question: 'What is the duration of the Bootcamps?',
      answer: 'Our Bootcamps are short-term intensive programs that typically range from 4-12 weeks depending on the technology and depth of coverage. They are designed for quick skill acquisition with flexible learning schedules.'
    },
    {
      question: 'Who can join these programs?',
      answer: 'Our programs are open to fresh graduates, working professionals looking to upskill, and anyone passionate about starting or advancing their career in technology. Basic computer knowledge is recommended.'
    },
    {
      question: 'What is the fee structure?',
      answer: 'Our fee structure varies based on the program and duration. Please contact us directly for detailed information about program fees, payment plans, and any available scholarships or discounts.'
    },
    {
      question: 'Are the classes online or offline?',
      answer: 'We offer both online and offline training options. Our Bangalore and Mysore offices host in-person classes, while we also provide live online sessions for remote learners with the same quality of instruction.'
    },
    {
      question: 'Do you provide certifications?',
      answer: 'Yes, upon successful completion of our programs, you will receive a certification from Vlinkin Professionals. Many of our courses also prepare you for industry-recognized certifications.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-white" data-testid="faqs-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Questions</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Find answers to common questions about our programs
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-xl shadow-md hover:shadow-lg transition-shadow"
              data-testid={`faq-item-${index}`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex justify-between items-center text-left"
                data-testid={`faq-question-${index}`}
              >
                <span className="text-lg font-semibold text-gray-900 pr-4">
                  {faq.question}
                </span>
                <span className="flex-shrink-0 text-blue-600">
                  {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                </span>
              </button>
              {openIndex === index && (
                <div
                  className="px-6 pb-5 text-gray-600 leading-relaxed"
                  data-testid={`faq-answer-${index}`}
                >
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">Still have questions?</p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-3 rounded-lg font-semibold hover:shadow-lg transform hover:-translate-y-1 transition-all"
            data-testid="faqs-contact-btn"
          >
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQs;